module.exports = __webpack_public_path__ + "img/topic-kisisel-gelisim.9d498c12.svg";